import React, {useRef, useState, useEffect, useMemo} from "react";
import {ChevronLeftIcon, ChevronRightIcon} from "@heroicons/react/24/solid";
import Api from "../../Api/api";
import {toast} from "react-toastify";
import {AES, enc} from "crypto-js";
import {useStateValue} from "../../states/StateProvider";
import MilestoneChart from "./components/chartjs/full/milestoneChart";
import MilestoneChartPreview from "./components/chartjs/preview/milestoneChartPreview";
import MilestonePotenzialChart from "./components/chartjs/full/milestonePotenzialChart";
import PieChartSwitcher from "./components/chartjs/full/infoPieChart";
import MilestonePotenzialChartPreview from "./components/chartjs/preview/milestonePotenzialChartPreview";
import PieChartSwitcherPreview from "./components/chartjs/preview/infoPieChartPreview";
import WiderVorlageTableComponent from "./components/wvTable";

const DashboardV2 = () => {
    const scrollRef = useRef(null);
    const [scrollIndex, setScrollIndex] = useState(0);
    const visibleItems = 2; // Number of visible items at a time
    const [project, setProject] = useState(true)
    const [milestones, setMilestones] = useState([])
    const [gesamtFortschritt, setGesamtFortschritt] = useState([])
    const [istData, setIstData] = useState([])
    const [gesamtData, setGesamtData] = useState([])
    const [bavPotenzialData, setBavPotenzialData] = useState([])
    const [gePotenzialData, setGEPotenzialData] = useState([])
    const [bkvPotenzialData, setBKVPotenzialData] = useState([])
    const [loading, setLoading] = useState(true)
    const [loadingPotenzial, setLoadingPotenzial] = useState(true)
    const [info, setInfo] = useState([])
    const [superAdmin, setSuperAdmin] = useState('')
    const [loadingStrofalle, setLoadingStrofalle] = useState(true)
    const [{
        secretKey, portal, dggAndHgsFilter, dggFilter, hgsFilter, ruvFilter
    }, dispatch] = useStateValue();
    const [selectedContent, setSelectedContent] = useState(null);
    const [selectedTitle, setSelectedTitle] = useState(null);
    const [selectedKey, setSelectedKey] = useState(1);
    const [wvData, setWvData] = useState([]);
    const [potenzialParams, setPotenzialParams] = useState([]);

    const handleBlockClickTitle = (content) => {
        setSelectedTitle(content);
    };

    const handleBlockClick = (content) => {
        setSelectedContent(content);
    };

    const handleSelectedKey = (key) => {
        setSelectedKey(key);
    };

    const decryptedBytes = localStorage.getItem('user') ? AES.decrypt(localStorage.getItem('user'), secretKey) : false;
    const user = JSON.parse(decryptedBytes.toString(enc.Utf8))
    const role = user.role

    useEffect(() => {
        setSuperAdmin(user.isSAdmin);

        const initialPortal = (() => {
            if (user.role === 'ExtDGG' || user.role === 'ManDGG') return 'dgg';
            if (user.role === 'ExtRUV' || user.role === 'ManRUV') return 'ruv';
            return localStorage.getItem('portal') || 'dgg';
        })();

        // Initialize filters based on user's portal role
        let initialDggAndHgs, initialDgg, initialHgs, initialRuv;

        if (user.role === 'ExtRUV' || user.role === 'ManRUV') {
            // RUV users: only RUV filter should be true
            initialDggAndHgs = false;
            initialDgg = false;
            initialHgs = false;
            initialRuv = true;
        } else if (user.role === 'ExtDGG' || user.role === 'ManDGG') {
            // DGG users: DGG+HGS by default
            initialDggAndHgs = true;
            initialDgg = false;
            initialHgs = false;
            initialRuv = false;
        } else {
            // Super admins and others: use localStorage or defaults based on current portal
            if (initialPortal === 'ruv') {
                initialDggAndHgs = localStorage.getItem('dggAndHgsFilter') === 'true' || false;
                initialDgg = localStorage.getItem('dggFilter') === 'true' || false;
                initialHgs = localStorage.getItem('hgsFilter') === 'true' || false;
                initialRuv = localStorage.getItem('ruvFilter') === 'true' || true;
            } else {
                initialDggAndHgs = localStorage.getItem('dggAndHgsFilter') === 'true' || true;
                initialDgg = localStorage.getItem('dggFilter') === 'true' || false;
                initialHgs = localStorage.getItem('hgsFilter') === 'true' || false;
                initialRuv = localStorage.getItem('ruvFilter') === 'true' || false;
            }
        }

        dispatch({type: 'SET_PORTAL', item: initialPortal});
        dispatch({type: 'SET_DGG_AND_HGS_FILTER', item: initialDggAndHgs});
        dispatch({type: 'SET_DGG_FILTER', item: initialDgg});
        dispatch({type: 'SET_HGS_FILTER', item: initialHgs});
        dispatch({type: 'SET_RUV_FILTER', item: initialRuv});

        localStorage.setItem('portal', initialPortal);
        localStorage.setItem('dggAndHgsFilter', initialDggAndHgs.toString());
        localStorage.setItem('dggFilter', initialDgg.toString());
        localStorage.setItem('hgsFilter', initialHgs.toString());
        localStorage.setItem('ruvFilter', initialRuv.toString());
    }, []);

    const handleCompanyFilterChange = (company) => {
        setLoadingPotenzial(true);
        setLoading(true);

        const isDGG = company === 'dgg';
        const isDGGAndHgs = company === 'dgg_hgs';

        dispatch({type: 'SET_DGG_AND_HGS_FILTER', item: isDGGAndHgs});
        dispatch({type: 'SET_DGG_FILTER', item: isDGG});
        dispatch({type: 'SET_HGS_FILTER', item: !isDGG && !isDGGAndHgs});

        localStorage.setItem('dggAndHgsFilter', isDGGAndHgs.toString());
        localStorage.setItem('dggFilter', isDGG.toString());
        localStorage.setItem('hgsFilter', (!isDGG && !isDGGAndHgs).toString());
    };

    const updateScrollIndex = () => {
        if (scrollRef.current) {
            const scrollLeft = scrollRef.current.scrollLeft;
            const itemWidth = scrollRef.current.scrollWidth / blockSettings.length;
            setScrollIndex(Math.round(scrollLeft / itemWidth));
        }
    };

    useEffect(() => {
        if (portal) {
            setSelectedKey(0)
            setLoading(true)
            setLoadingPotenzial(true)
            let {dgg, hgs, ruv, dggAndHgs} = normalizeFilters();

            if (dggAndHgs) {
                dgg = true
                hgs = true
                ruv = false
            }
            Api().get(`/getDashboardCountsV2/${user.ID}/${dgg}/${hgs}/${ruv}`)
                .then(res => {
                    setInfo(res.data);
                    setLoading(false);
                })
                .catch(() => {
                    setLoading(false);
                });
        }
    }, [portal, dggFilter, ruvFilter, hgsFilter, dggAndHgsFilter]);

    useEffect(() => {
        if (scrollRef.current) {
            scrollRef.current.addEventListener("scroll", updateScrollIndex);
        }
        return () => {
            if (scrollRef.current) {
                scrollRef.current.removeEventListener("scroll", updateScrollIndex);
            }
        };
    }, []);

    useEffect(() => {
        if (portal) {
            let {dgg, hgs, ruv, dggAndHgs} = normalizeFilters();
            if (dggAndHgsFilter) {
                dgg = true
                hgs = true
                ruv = false
            }
            let url1 = 'getIST'
            let url2 = 'getGF'
            if (user?.ID) {
                setLoading(true)
                setLoadingPotenzial(true)
                Api().get(`/${url1}/${user?.ID}/${dgg}/${hgs}/${ruv}`).then(res => {
                    const grouped = [];

                    res.data.forEach(item => {
                        const key = `${item.No}__${item.Fortschritt}`; // stable grouping key
                        const existing = grouped.find(g => `${g.No}__${g.Fortschritt}` === key);

                        if (existing) {
                            existing.FP = (parseInt(existing.FP, 10) + parseInt(item.FP, 10)).toString();
                            existing.MA = (parseInt(existing.MA, 10) + parseInt(item.MA, 10)).toString();
                        } else {
                            grouped.push({ ...item });
                        }
                    });

                    // Now safely adjust Fortschritt labels *after* grouping
                    grouped.forEach(item => {
                        const no = parseInt(item.No, 10);
                        if (
                            (no === 13 && (dgg || hgs)) ||
                            (no === 18 && ruv)
                        ) {
                            item.Fortschritt += " (lfd. Jahr)";
                        }
                    });

                    setIstData(grouped);
                }).catch(e => {
                    console.log(e)
                    toast.error('etwas ist schief gelaufen!');
                }).then(r => {
                    Api().get(`/${url2}/${user?.ID}/${dgg}/${hgs}/${ruv}`).then(res => {
                        const grouped = [];

                        res.data.forEach(item => {
                            const key = `${item.No}__${item.Fortschritt}`; // stable grouping key
                            const existing = grouped.find(g => `${g.No}__${g.Fortschritt}` === key);

                            if (existing) {
                                existing.FP = (parseInt(existing.FP, 10) + parseInt(item.FP, 10)).toString();
                                existing.MA = (parseInt(existing.MA, 10) + parseInt(item.MA, 10)).toString();
                            } else {
                                grouped.push({ ...item });
                            }
                        });

                        // Now safely adjust Fortschritt labels *after* grouping
                        grouped.forEach(item => {
                            const no = parseInt(item.No, 10);
                            if (
                                (no === 13 && (dgg || hgs)) ||
                                (no === 18 && ruv)
                            ) {
                                item.Fortschritt += " (lfd. Jahr)";
                            }
                        });
                        setGesamtFortschritt(grouped)
                        setLoading(false)
                    }).catch(e => {
                        console.log(e)
                        toast.error('etwas ist schief gelaufen!')
                        setLoading(false)
                    })
                });
            }
        }
    }, [project, portal, dggFilter, hgsFilter, ruvFilter, dggAndHgsFilter]);

    useEffect(() => {
        getPotenzialParameters()
    }, [project, portal, dggFilter, hgsFilter, ruvFilter, dggAndHgsFilter]);

    useEffect(() => {
        const updatePotenzialData = async () => {
            setLoadingPotenzial(true);
            await Promise.resolve(calculateAndSetBavPotenzialData());
            await Promise.resolve(calculateAndSetGEPotenzialData());
            await Promise.resolve(calculateAndSetbKVotenzialData());

            setLoadingPotenzial(false);
        };

        if (potenzialParams.length > 0 && istData.length > 0) {
            updatePotenzialData();
        }
    }, [potenzialParams, istData]);


    useEffect(() => {
        setLoadingStrofalle(true)
        let data = new FormData()
        data.append('userID', user.ID)
        data.append('portal', portal)

        Api().post('/sp_getDataDashWVSF', data).then(res => {
            const sortedData = res.data.sort((a, b) => new Date(a.Datum) - new Date(b.Datum));
            setWvData(sortedData)
            setLoadingStrofalle(false)
        });
    }, [istData]);

    const normalizeFilters = () => {
        const isFalse = (val) => val === false || val === 'false';

        let dggAndHgs = dggAndHgsFilter;
        let dgg = dggFilter;
        let hgs = hgsFilter;
        let ruv = ruvFilter;

        if (isFalse(dggFilter) && isFalse(hgsFilter) && isFalse(ruvFilter) && isFalse(dggAndHgsFilter)) {
            if (portal === 'dgg') {
                dggAndHgs = true;
                dgg = false;
                hgs = false;
                ruv = false;
                if (dispatch) {
                    dispatch({type: 'SET_DGG_AND_HGS_FILTER', item: true});
                    dispatch({type: 'SET_DGG_FILTER', item: false});
                    dispatch({type: 'SET_HGS_FILTER', item: false});
                    dispatch({type: 'SET_RUV_FILTER', item: false});
                }
                localStorage.setItem('dggAndHgsFilter', 'true');
                localStorage.setItem('dggFilter', 'false');
                localStorage.setItem('hgsFilter', 'false');
                localStorage.setItem('ruvFilter', 'false');
            } else if (portal === 'ruv') {
                dggAndHgs = false;
                dgg = false;
                hgs = false;
                ruv = true;
                if (dispatch) {
                    dispatch({type: 'SET_DGG_AND_HGS_FILTER', item: false});
                    dispatch({type: 'SET_DGG_FILTER', item: false});
                    dispatch({type: 'SET_HGS_FILTER', item: false});
                    dispatch({type: 'SET_RUV_FILTER', item: true});
                }
                localStorage.setItem('dggAndHgsFilter', 'false');
                localStorage.setItem('dggFilter', 'false');
                localStorage.setItem('hgsFilter', 'false');
                localStorage.setItem('ruvFilter', 'true');
            }
        }

        return {dgg, hgs, ruv, dggAndHgs};
    };

    const getPotenzialParameters = () => {
        Api().get("/getPotenzialParameters").then(res => {
            setPotenzialParams(res.data);
        }).catch(e => {
            setLoading(false)
            toast.error("Fehler beim Laden der Potenzial-Parameter.");
        });
    }

    const setGesamtFortschrittData = () => {
        const result = [];
        let accumulatedSum = 0;
        let accumulatedMA = 0;

        for (let i = istData.length - 1; i >= 0; i--) {
            const summe = parseInt(istData[i].FP, 10);
            const ma = parseInt(istData[i].MA, 10);
            accumulatedSum += summe;
            accumulatedMA += ma;

            result.unshift({
                No: istData[i].No,
                Fortschritt: istData[i].Fortschritt,
                FP: accumulatedSum.toString(),
                MA: accumulatedMA.toString(),
            });
        }

        setGesamtData(result);
    }

    const calculateAndSetBavPotenzialData = () => {
        const result = []
        let summeToShow = 0

        const bAV = potenzialParams.find(p => p.produkt === "bAV");
        const params = {
            bevertungsSumme: parseFloat(bAV?.bewertungssumme) || 0, beteiligung: parseFloat(bAV?.maBeteiligung) || 0
        };

        for (let i = istData.length - 1; i >= 0; i--) {
            const summe = parseInt(istData[i].FP, 10);
            const ma = parseInt(istData[i].MA, 10);
            summeToShow = parseFloat((ma * params.beteiligung / 100 * params.bevertungsSumme / 1000000).toFixed(1));

            result.unshift({
                No: istData[i].No, Fortschritt: istData[i].Fortschritt, FP: summeToShow, MA: ma,
            });
        }

        setBavPotenzialData(result);
    }

    const calculateAndSetGEPotenzialData = () => {
        const result = []
        let summeToShow = 0

        const bAV = potenzialParams.find(p => p.produkt === "GE");
        const params = {
            bevertungsSumme: parseFloat(bAV?.bewertungssumme || 0), beteiligung: parseFloat(bAV?.maBeteiligung || 0)
        };

        for (let i = istData.length - 1; i >= 0; i--) {
            const summe = parseInt(istData[i].FP, 10);
            const ma = parseInt(istData[i].MA, 10);
            summeToShow = parseFloat((ma * params.beteiligung / 100 * params.bevertungsSumme / 1000).toFixed(1));

            result.unshift({
                No: istData[i].No, Fortschritt: istData[i].Fortschritt, FP: summeToShow, MA: ma,
            });
        }

        setGEPotenzialData(result);
    }

    const calculateAndSetbKVotenzialData = () => {
        const result = []
        let summeToShow = 0

        const bAV = potenzialParams.find(p => p.produkt === "bKV");
        const params = {
            bevertungsSumme: parseFloat(bAV?.bewertungssumme || 0), beteiligung: parseFloat(bAV?.maBeteiligung || 0)
        };

        for (let i = istData.length - 1; i >= 0; i--) {
            const summe = parseInt(istData[i].FP, 10);
            const ma = parseInt(istData[i].MA, 10);
            summeToShow = parseFloat((ma * params.beteiligung / 100 * params.bevertungsSumme / 1000).toFixed(1));

            // result.unshift({
            //     milestoneID: istData[i].No, milestone: istData[i].Fortschritt, summe: summeToShow,
            // });

            result.unshift({
                No: istData[i].No, Fortschritt: istData[i].Fortschritt, FP: summeToShow, MA: ma,
            });
        }

        setBKVPotenzialData(result);
    }

    const scrollLeft = () => {
        if (scrollRef.current) {
            scrollRef.current.scrollBy({left: -scrollRef.current.clientWidth / visibleItems, behavior: "smooth"});
        }
    };

    const scrollRight = () => {
        if (scrollRef.current) {
            scrollRef.current.scrollBy({left: scrollRef.current.clientWidth / visibleItems, behavior: "smooth"});
        }
    };

    function portalSelect(e) {
        setLoading(true);
        setLoadingPotenzial(true);

        const selectedPortal = e.target.value;

        dispatch({type: 'SET_PORTAL', item: selectedPortal});
        localStorage.setItem('portal', selectedPortal);

        if (selectedPortal === 'dgg') {
            // Try to restore filters from localStorage
            const storedDggAndHgs = localStorage.getItem('dggAndHgsFilter');
            const storedDgg = localStorage.getItem('dggFilter');
            const storedHgs = localStorage.getItem('hgsFilter');

            const dggAndHgs = storedDggAndHgs === 'true';
            const dgg = storedDgg === 'true';
            const hgs = storedHgs === 'true';

            // If both are false, default to DGG
            const fallbackToDggAndHgs = !dgg && !hgs && !dggAndHgs;

            dispatch({type: 'SET_DGG_AND_HGS_FILTER', item: fallbackToDggAndHgs || dggAndHgs});
            dispatch({type: 'SET_DGG_FILTER', item: dgg});
            dispatch({type: 'SET_HGS_FILTER', item: hgs});

            localStorage.setItem('dggAndHgsFilter', (fallbackToDggAndHgs || dggAndHgs).toString());
            localStorage.setItem('dggFilter', dgg.toString());
            localStorage.setItem('hgsFilter', hgs.toString());

            dispatch({type: 'SET_RUV_FILTER', item: false});
            localStorage.setItem('ruvFilter', 'false');
        } else if (selectedPortal === 'ruv') {
            // Reset filters and enable RUV only
            dispatch({type: 'SET_DGG_AND_HGS_FILTER', item: false});
            dispatch({type: 'SET_DGG_FILTER', item: false});
            dispatch({type: 'SET_HGS_FILTER', item: false});
            dispatch({type: 'SET_RUV_FILTER', item: true});

            localStorage.setItem('dggAndHgsFilter', 'false');
            localStorage.setItem('dggFilter', 'false');
            localStorage.setItem('hgsFilter', 'false');
            localStorage.setItem('ruvFilter', 'true');
        }
    }

    const blockSettings = useMemo(() => ([{
        key: 1,
        title: 'IST-Projektstatus',
        data: istData,
        component: MilestoneChart,
        previewComponent: MilestoneChartPreview,
        loading: loading,
        label: 'FP',
        barThickness: portal === 'ruv' ? 30 : 30,
        labelsTableRowThickness: portal === 'ruv' ? "39px" : "59px",
        barHeight: portal === 'ruv' ? 42.8 : 64.4,
        barThicknessPreview: portal === 'ruv' ? 10 : 10,
        labelsTableRowThicknessPreview: portal === 'ruv' ? "1px" : "22px",
        barHeightPreview: portal === 'ruv' ? 19.5 : 26,
    }, {
        key: 2,
        title: 'Gesamtfortschritt',
        data: gesamtFortschritt,
        component: MilestoneChart,
        previewComponent: MilestoneChartPreview,
        mainBackground: 'rgb(251, 120, 72)',
        secondaryBackground: 'rgb(255, 242, 237)',
        loading: loadingPotenzial,
        label: 'FP',
        barThickness: portal === 'ruv' ? 30 : 30,
        labelsTableRowThickness: portal === 'ruv' ? "39px" : "59px",
        barHeight: portal === 'ruv' ? 42.8 : 64.4,
        barThicknessPreview: portal === 'ruv' ? 10 : 10,
        labelsTableRowThicknessPreview: portal === 'ruv' ? "1px" : "22px",
        barHeightPreview: portal === 'ruv' ? 19.5 : 26,
    }, {
        key: 3,
        title: 'Info',
        data: info,
        component: PieChartSwitcher,
        previewComponent: PieChartSwitcherPreview,
        mainBackground: 'rgb(201, 8, 30)',
        secondaryBackground: 'rgb(252, 240, 242)',
        loading: loading,
        label: '',
        barThickness: portal === 'ruv' ? 30 : 30,
        labelsTableRowThickness: portal === 'ruv' ? "39px" : "59px",
        barHeight: portal === 'ruv' ? 42.8 : 64.4,
        barThicknessPreview: portal === 'ruv' ? 10 : 10,
        labelsTableRowThicknessPreview: portal === 'ruv' ? "1px" : "22px",
        barHeightPreview: portal === 'ruv' ? 19.5 : 26,
    }, {
        key: 4,
        title: 'bAV-Potenzial Mio.',
        data: bavPotenzialData,
        component: MilestoneChart,
        previewComponent: MilestoneChartPreview,
        mainBackground: 'rgb(201, 8, 30)',
        secondaryBackground: 'rgb(252, 240, 242)',
        loading: loadingPotenzial,
        label: 'BWS',
        barThickness: portal === 'ruv' ? 30 : 30,
        labelsTableRowThickness: portal === 'ruv' ? "39px" : "59px",
        barHeight: portal === 'ruv' ? 42.8 : 64.4,
        barThicknessPreview: portal === 'ruv' ? 10 : 10,
        labelsTableRowThicknessPreview: portal === 'ruv' ? "1px" : "22px",
        barHeightPreview: portal === 'ruv' ? 19.5 : 26,
    }, {
        key: 5,
        title: 'bKV-Potenzial Tsd.',
        data: bkvPotenzialData,
        component: MilestoneChart,
        previewComponent: MilestoneChartPreview,
        mainBackground: 'rgb(93, 169, 233)',
        secondaryBackground: 'rgb(239, 247, 253)',
        loading: loadingPotenzial,
        label: 'BWS',
        barThickness: portal === 'ruv' ? 30 : 30,
        labelsTableRowThickness: portal === 'ruv' ? "39px" : "59px",
        barHeight: portal === 'ruv' ? 42.8 : 64.4,
        barThicknessPreview: portal === 'ruv' ? 10 : 10,
        labelsTableRowThicknessPreview: portal === 'ruv' ? "1px" : "22px",
        barHeightPreview: portal === 'ruv' ? 19.5 : 26,
    }, {
        key: 6,
        title: 'GE-Potenzial Tsd.',
        data: gePotenzialData,
        component: MilestoneChart,
        previewComponent: MilestoneChartPreview,
        mainBackground: 'rgb(0, 145, 110)',
        secondaryBackground: 'rgb(230, 244, 241)',
        loading: loadingPotenzial,
        label: 'BWS',
        barThickness: portal === 'ruv' ? 30 : 30,
        labelsTableRowThickness: portal === 'ruv' ? "39px" : "59px",
        barHeight: portal === 'ruv' ? 42.8 : 64.4,
        barThicknessPreview: portal === 'ruv' ? 10 : 10,
        labelsTableRowThicknessPreview: portal === 'ruv' ? "1px" : "22px",
        barHeightPreview: portal === 'ruv' ? 19.5 : 26,
    }]), [portal, istData, gesamtFortschritt, loading, loadingPotenzial, info, bavPotenzialData, bkvPotenzialData, gePotenzialData]);

    return (<div className="p-6 bg-gray-100 min-h-screen dashboardContainer">
        {/* Firmenprojekt Selection */}
        <div className="flex items-center py-1 rounded-lg mb-2 w-full">
            <h1 className="text-2xl lg:text-left mr-5">Firmenprojekt</h1>

            {portal === 'dgg' && (<div className="flex gap-4">
                <label className="flex items-center space-x-2">
                    <input
                        type="radio"
                        name="companyFilter"
                        value="dgg_hgs"
                        className="form-radio"
                        checked={dggAndHgsFilter}
                        disabled={loading}
                        onChange={() => handleCompanyFilterChange('dgg_hgs')}
                    />
                    <span>DGG+HSG</span>
                </label>
                <label className="flex items-center space-x-2">
                    <input
                        type="radio"
                        name="companyFilter"
                        value="dgg"
                        className="form-radio"
                        checked={dggFilter}
                        disabled={loading}
                        onChange={() => handleCompanyFilterChange('dgg')}
                    />
                    <span>DGG</span>
                </label>
                <label className="flex items-center space-x-2">
                    <input
                        type="radio"
                        name="companyFilter"
                        value="hgs"
                        className="form-radio"
                        checked={hgsFilter}
                        disabled={loading}
                        onChange={() => handleCompanyFilterChange('hgs')}
                    />
                    <span>HSG</span>
                </label>
            </div>)}

            {(superAdmin === '1' || role === 'Internal' || role === 'Controller') && (
                <div className="ml-auto flex justify-start items-center bg-transparent py-2 px-4 rounded-sm">
                    <p className="mr-2 text-grey">Portal:</p>
                    <select
                        disabled={loading}
                        className="text-center text-mainBlue pr-1 bg-transparent border border-offWhite rounded-sm lg:w-fit"
                        onChange={portalSelect}
                        value={portal}
                    >
                        <option value="dgg">DGG</option>
                        <option value="ruv">R+V</option>
                    </select>
                </div>)}
        </div>

        {/* Main Content Grid */}
        <div className="grid grid-cols-1 xl:grid-cols-2 gap-4 h-[80vh]">
            <div className="bg-white p-4 rounded-lg shadow-md w-full h-full">
                <h2 className="font-semibold text-start text-2xl mb-2">
                    {blockSettings[selectedKey]?.title ?? "IST-Projektstatus"}
                </h2>

                <div className="bg-gray-200 flex items-center justify-center" style={{height: 'calc(100% - 2rem)'}}>
                    {(() => {
                        const block = blockSettings[selectedKey];
                        if (!block) return null;
                        const Component = block.component;
                        return (<Component
                            loading={block.loading}
                            data={block.data}
                            mainBackground={block.mainBackground}
                            secondaryBackground={block.secondaryBackground}
                            label={block.label}
                            barThickness={block.barThickness}
                            labelsTableRowThickness={block.labelsTableRowThickness}
                            barHeight={block.barHeight}
                        />);
                    })()}
                </div>
            </div>

            {/* Right: Other Blocks - Takes Remaining 50% Width */}
            <div className="flex flex-col gap-4 w-full h-full">
                {/* Filters & Table - Takes 50% Height */}
                <div className="bg-white p-4 rounded-lg shadow-md h-1/2 xl:order-1 order-2">
                    <WiderVorlageTableComponent loading={loadingStrofalle} data={wvData} portal={portal}/>
                </div>

                {/* Bottom Section with Scrollable Charts - Takes 50% Height */}
                <div className="relative h-1/2 min-h-min flex flex-col items-center xl:order-2 order-1">
                    <div
                        ref={scrollRef}
                        className="flex gap-6 overflow-x-hidden scrollbar-hide scroll-smooth h-full w-full"
                        style={{scrollBehavior: "smooth", whiteSpace: "nowrap"}}
                    >
                        {blockSettings.map((block, key) => {
                            const Component = block.component;
                            const PreviewComponent = block.previewComponent;

                            return (<div
                                key={key}
                                style={{minWidth: '48%'}}
                                className={`bg-white p-4 rounded-lg shadow-md h-full flex items-center justify-center cursor-pointer 
                                    border-2 ${selectedKey === key ? 'border-mainBlue bg-lightBlue2' : 'border-white'}`}
                                onClick={() => {
                                    handleBlockClick(<Component
                                        loading={block.loading}
                                        data={block.data}
                                        mainBackground={block.mainBackground}
                                        secondaryBackground={block.secondaryBackground}
                                        label={block.label}
                                        barThickness={block.barThickness}
                                        labelsTableRowThickness={block.labelsTableRowThickness}
                                        barHeight={block.barHeight}
                                    />);
                                    handleBlockClickTitle(block.title);
                                    handleSelectedKey(key);
                                }}
                            >
                                <PreviewComponent
                                    title={block.title}
                                    loading={block.loading}
                                    data={block.data}
                                    active={selectedKey === key}
                                    mainBackground={block.mainBackground}
                                    secondaryBackground={block.secondaryBackground}
                                    label={block.label}
                                    barThickness={block.barThicknessPreview}
                                    labelsTableRowThickness={block.labelsTableRowThicknessPreview}
                                    barHeight={block.barHeightPreview}
                                />
                            </div>);
                        })}
                    </div>
                    {/* Scroll Controls */}
                    <div className="flex items-center justify-between w-full mt-2">
                        <button
                            className="bg-white p-2 rounded-full shadow-md"
                            onClick={scrollLeft}
                        >
                            <ChevronLeftIcon className="w-6 h-6 text-gray-700"/>
                        </button>
                        {/* Scroll Indicator Dots */}
                        <div className="flex space-x-2 mx-4">
                            {[...Array(blockSettings.length - visibleItems + 1)].map((_, index) => (<span
                                key={index}
                                className={`h-3 w-3 rounded-full ${scrollIndex === index ? "bg-mainBlue" : "bg-white"}`}
                            />))}
                        </div>
                        <button
                            className="bg-white p-2 rounded-full shadow-md"
                            onClick={scrollRight}
                        >
                            <ChevronRightIcon className="w-6 h-6 text-gray-700"/>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>);
};

export default DashboardV2;
